export const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) {
    return '-';
  }

  return new Date(dateStr).toLocaleDateString('fr-FR');
};
